import * as React from 'react';
import { TranslationsProvider } from '../../i18next';
import { Translation } from 'react-i18next';
import { ReviewAppModal } from './review-app-modal';
function ReviewAppModalExport({ locale, ...reviewAppModalProps }) {
    return (React.createElement(TranslationsProvider, { locale: locale },
        React.createElement(Translation, null, (t) => React.createElement(ReviewAppModal, { ...reviewAppModalProps, t: t }))));
}
export { ReviewAppModalExport };
//# sourceMappingURL=review-app-modal-export.js.map